import type { ReactNode } from 'react';
import { canAny } from '../api/client';
import { useMe } from '../features/auth/session';
import { PortalDashboard } from '../features/dashboard/PortalDashboard';

/**
 * Landing page ("Panou"): the operational dashboard, or for a portal account (no operations.view: the authority
 * observer, "AFM") a simple dashboard of its client with the way to the AFM reports. It used to redirect the observer
 * to /reports/dashboard, so "Panou" and "Reports / AFM" led to the same page (user, 2026-10-10).
 */
export function Home({ dashboard }: { dashboard: ReactNode }) {
  const me = useMe().data;
  if (me && !canAny(me, 'operations.view')) return <PortalDashboard />;
  return dashboard;
}
